module.exports = __webpack_public_path__ + "static/media/badge-price-starter.aa6449b7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/images/badge-price-starter.svg
// module id = 2164
// module chunks = 0